import {
    AddShoppingCartSharp,
    Money,
    PersonOutlineOutlined, ShoppingBagOutlined,
    ShoppingCartOutlined
} from '@mui/icons-material';
import './widget.scss';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { off, onValue, ref } from 'firebase/database';
import { db } from '../../firebase';
import { FaMoneyBill } from 'react-icons/fa';

const Widget = ({ type }) => {
    const [countEmployee, setCountEmployee] = useState(0);
    const [countProductTotal, setCountProductTotal] = useState(0);
    const [countLowProduct, setCountLowProduct] = useState(0);
    const [totalCost, setTotalCost] = useState(0);
    const [totalRetail, setTotalRetail] = useState(0);

    useEffect(() => {
        const dbRef = ref(db, `Products/`);
        try {
            onValue(dbRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    // Calculate total product count
                    setCountProductTotal(Object.keys(data).length);

                    // Filter data to include only low quantity products
                    const filteredData = Object.fromEntries(
                        Object.entries(data).filter(([key, value]) =>
                            Number(value.quantity) < (Number(value.min_quantity) || 5)
                        )
                    );

                    // Calculate count of low quantity products
                    setCountLowProduct(Object.keys(filteredData).length);

                    // Total Cost & Retail
                    let cost = 0;
                    let retail = 0;
                    Object.values(data).forEach((product) => {
                        const quantity = parseFloat(product.quantity) || 0;
                        const costPrice = parseFloat(product.cost) || 0;
                        const retailPrice = parseFloat(product.retail) || 0;

                        // Multiply quantity by cost and retail price
                        cost += quantity * costPrice;
                        retail += quantity * retailPrice;
                    });
                    setTotalCost(cost);
                    setTotalRetail(retail);
                    // console.log('product total cost and retail', totalCost, totalRetail);

                }
            });
            return () => off(dbRef); //clean up the listener
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [])


    useEffect(() => {
        const dbRef = ref(db, `Users/`);
        try {
            onValue(dbRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    setCountEmployee(Object.keys(data).length);
                    // console.log('employee count', countEmployee);
                }
            });
            return () => off(dbRef);  //clean up the listener

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [])

    // let data;
    let data = {
        title: "Unknown",
        isMoney: false,
        amount: 0,
        linkTitle: "Unknown Link",
        link: '/',
        icon: null,
    };

    switch (type) {
        case 'employee':
            data = {
                title: "Employees",
                isMoney: false,
                amount: countEmployee,
                linkTitle: "See all Employees",
                link: '/employees',
                icon: (<PersonOutlineOutlined
                    className='icon'
                    style={{
                        color: 'crimson',
                        backgroundColor: 'rgba(255,0,0,0.2)',
                    }} />
                ),
            };
            break;

        case 'total-product':
            data = {
                title: "Total Products",
                isMoney: false,
                amount: countProductTotal,
                linkTitle: "See all Products",
                link: '/inventory',
                icon: (<ShoppingCartOutlined
                    className='icon'
                    style={{
                        backgroundColor: 'rgba(218,165,32,0.2)',
                        color: 'goldenrod',

                    }}
                />
                ),
            };
            break;
        case 'low-product':
            data = {
                title: "Low Stock Products",
                isMoney: false,
                amount: countLowProduct,
                linkTitle: "See Low Stock Products",
                link: '/inventory-alert',
                icon: (<AddShoppingCartSharp
                    className='icon'
                    style={{
                        backgroundColor: 'rgba(218,165,32,0.2)',
                        color: 'goldenrod',

                    }}
                />
                ),
            };
            break;
        case 'total-cost':
            data = {
                title: "Total Cost",
                isMoney: true,
                amount: `$${totalCost.toFixed(2)}`,
                // linkTitle: "See Low Stock Products",
                // link: '/inventory-alert',
                icon: (<Money
                    className='icon'
                    style={{
                        backgroundColor: 'rgba(218,165,32,0.2)',
                        color: 'goldenrod',

                    }}
                />
                ),
            };
            break; case 'total-retail':
            data = {
                title: "Total Retail Price",
                isMoney: true,
                amount: `$${totalRetail.toFixed(2)}`,
                // linkTitle: "See Low Stock Products",
                // link: '/inventory-alert',
                icon: (<FaMoneyBill
                    className='icon'
                    style={{
                        backgroundColor: 'rgba(218,165,32,0.2)',
                        color: 'goldenrod',

                    }}
                />
                ),
            };
            break;
        case 'order':
            data = {
                title: "Orders",
                isMoney: false,
                amount: 2,
                link: "See all Orders",
                icon: (<ShoppingBagOutlined
                    className='icon'
                    style={{
                        backgroundColor: 'rgba(0,128,0,0.2)',
                        color: 'green',

                    }}
                />
                ),
            };
            break;
        default:
            break;
    }


    return (
        <div className='widget'>
            <div className='left'>
                <span className='title'>
                    {data.title}
                </span>
                <span className='counter'>{data.amount}</span>
                <span className='link'>
                    <Link to={data.link}> {data.linkTitle}</Link>
                </span>

            </div>
            <div className="right">
                {/* <div className="percentage positive">
                    <KeyboardArrowUp />
                    10%
                </div> */}
                {data.icon}
            </div>
        </div>
    )
}

export default Widget